import { z } from "zod";

export const BuiltInGradientsValues = [
  "Yellow",
  "Lime",
  "SeaGreen",
  "Turquoise",
  "Blue",
  "NavyBlue",
  "Purple",
  "Pink",
  "Orange",
  "Black",
] as const;

export const BuiltInGradientsEnum = z.enum(BuiltInGradientsValues);
export type BuiltInGradients = z.infer<typeof BuiltInGradientsEnum>;
